const { __ } = wp.i18n;
const i18n = {};

// RenamerField

i18n.GALLERY = __( 'Gallery', 'meow-lightbox' );

// Dashboard

i18n.DASHBOARD = __( 'Dashboard', 'meow-lightbox' );


i18n.TOOLBAR = {
    DOWNLOAD: __( 'Download Image', 'meow-lightbox' ),
    PLAY: __( 'Start Slideshow', 'meow-lightbox' ),
    PAUSE: __( 'Stop Slideshow', 'meow-lightbox' ),
    MAP_SHOW: __( 'Show on Map', 'meow-lightbox' ),
    MAP_IMAGE: __( 'Show Image', 'meow-lightbox' ),
    FULLSCREEN: __( 'Full Screen', 'meow-lightbox' ),
    SHRINK: __( 'Shrink', 'meow-lightbox' ),
    CLOSE: __( 'Close', 'meow-lightbox' ),
    SHARE_ON: __( 'Share On', 'meow-lightbox' ),
}

export default i18n;

